import { QueryKey } from "@tanstack/react-query";
import { ActualFundType } from "@constants/funds-data";

const API_URL = import.meta.env.VITE_API_URL || "http://localhost:8000";

const getFetchLink = (fund_id: string) =>
  `${API_URL}/fund/${fund_id}`;

const options: RequestInit = {
  method: "GET",
  mode: "cors",
  headers: {
    "Content-Type": "application/json",
  },
};

export const fetchFundDetails = async ({
  queryKey,
}: {
  queryKey: QueryKey;
}): Promise<ActualFundType> => {
  const fund_id = (queryKey[1] as string) ?? "";

  if (!fund_id) {
    throw new Error("Fund ID is required");
  }

  try {
    const res = await fetch(getFetchLink(fund_id), options);

    if (!res.ok) {
      throw new Error(`API responded with status ${res.status}`);
    }

    const fund: ActualFundType = await res.json();
    return fund;
  } catch (e) {
    console.error("fetchFundDetails error:", e);
    throw new Error(`Failed to fetch fund details: ${(e as Error).message}`);
  }
};
